
export const MEDICAL_SOLUTIONS_URL = "https://healthcaresolutions.spradling.group/en"